module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAKCAYAAACE2W/HAAAAAXNSR0IArs4c6QAAAIdJREFUKBWVi8ENgCAQBLnEhC8NWAJF0I5f2qAOyrAIS9AC/PoS94wQIheDJAvL3YxKKUXk74kKhkHWHyazRvFBccjZITPjbilfGIQOMWS+vJA0snzIvNNFqAsWFjkEmWe2ZpsOwAuib8D3ABIhcyVzpzcn/gGOyP5klKBBGhLRBmniHXeJuQBDTkVT6Efw3wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/arrow_down.png
// module id = 1655
// module chunks = 1